module.exports = __webpack_public_path__ + "static/profile-bg-baf6b40a654b078399e93e3d9cb6d455.jpg";